import {
    FontWeights,
    IconButton,
    //DefaultButton,
    Modal,
    PrimaryButton,
    getTheme,
    mergeStyleSets
} from "@fluentui/react";
import { Stack } from "@fluentui/react/lib/Stack";
import { CustomFontText } from "components/customFontText/CustomFontText";
import { styles } from "components/dialogs/employees/styles";
import { leadVehicleType } from "constants/constants";
import { cancelIcon } from "constants/styles";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import {
    useSelector
} from "react-redux";
import { AppState } from "store";


interface IProps {
    onDismiss: () => void;
    isOpen: boolean;
    handleImportVehicle: (data: any) => void;
    handleAddVehicle: () => void;
    leadList: any
}

export const LeadFoundDialog: FunctionComponent<IProps> = ({
    onDismiss,
    isOpen,
    handleImportVehicle,
    handleAddVehicle,
    leadList
}) => {
    const [selectedVehicleLeadList, setSelectedvehicleLeadList] = useState([]);
    const [selectedLead, setSelectedLead] = useState<any>(null);
    const [selectedVehicleLead, setSelectedVehicleLead] = useState(null);
    const driveCentricLead = useSelector((state: AppState) => state.dealTracker.driveCentricLead) as any;

    useEffect(() => {
        if (driveCentricLead) {
            const selectCustomerLead = driveCentricLead.find(
                (lead) => lead.leadId === leadList
            );

            setSelectedLead(selectCustomerLead);

            const vehicleList = selectCustomerLead?.vehicles?.filter(
                (vehicle) => vehicle.type === leadVehicleType.buy.key
            ) || [];

            const result = vehicleList.map((item, index) => ({
                id: index + 1,
                ...item,
            }));

            setSelectedVehicleLead(result[0]);
            setSelectedvehicleLeadList(result);
        }
    }, [leadList, driveCentricLead]);

    const handleSelect = () => {
        if (selectedVehicleLead) {
            const { id, ...data } = selectedVehicleLead;
            handleImportVehicle(data);
        }
    };


    return (
        <>
            <Modal
                isOpen={isOpen}
                isBlocking={true}
                styles={{ root: { zIndex: 10 } }}
                className="createDealRecord vehicleInfoHeights updateEmployeeDialogHeight"
                containerClassName={`${contentStyles.container} inv-srch-mod`}
            >
                <div className={contentStyles.header + " inventory-popup"}>
                    <CustomFontText className="formTitle">Lead Found</CustomFontText>
                    <IconButton
                        styles={iconButtonStyles}
                        iconProps={cancelIcon}
                        ariaLabel="Close popup modal"
                        onClick={onDismiss}
                    />
                </div>
                <>
                    <div className={contentStyles.body} style={{padding:'10px 50px'}}>
                          <Row>
                                <Col>
                                    <div style={{textAlign: "left" }}>
                                        <label className="lbl-text">
                                            {`Lead found for ${selectedLead?.customer?.fullName}. Please confirm purchase vehicle:`}
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                        <Stack>
                            <Row justify="center">
                                <Col md={12}>
                                    {selectedVehicleLeadList.length > 0 ? (
                                        selectedVehicleLeadList.map((lead, index) => (
                                            <Row key={index}>
                                                <Col style={{ display: "flex", marginTop: "10px" }} >
                                                    <div onClick={() => setSelectedVehicleLead(lead)}>
                                                        <label style={{ display: "flex" }} className="radio-option">
                                                            <input
                                                                type="radio"
                                                                name="lead"
                                                                value={lead.id}
                                                                checked={selectedVehicleLead?.id === lead.id}
                                                                onChange={() => setSelectedVehicleLead(lead)}
                                                                style={{ marginRight: "10px" }}
                                                            />
                                                            <div>
                                                                <div>VIN: {lead.vin ? lead.vin : "No data"}</div>
                                                                <div>
                                                                    YMM: {lead.year ? `${lead.year} ${lead.make} ${lead.model}` : "No data"}
                                                                </div>
                                                                <div>Trim: {lead.trim ? lead.trim : "No data"}</div>
                                                                <div>Stock No: {lead.stock ? lead.stock : "No data"}</div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        ))
                                    ) : (
                                        "No vehicle data found"
                                    )}
                                </Col>
                            </Row>
                        </Stack>
                    </div>
                    <div className={contentStyles.footer}>
                        <Stack tokens={styles.buttonTokens} horizontal horizontalAlign="center">
                            <Row className="inventoryRowSection footerBtn cusNoNotFoundFoot">
                                <Col>
                                    <PrimaryButton
                                        style={{ float: "left" }}
                                        disabled={selectedVehicleLeadList.length === 0}
                                        onClick={handleSelect}
                                        text="Import Vehicle Data"
                                        className="cusNoNotFoundDiaBtnHeight"
                                    />
                                </Col>
                                <Col>
                                    <PrimaryButton
                                        text="Add Vehicle Manually"
                                        style={{ float: "right" }}
                                        onClick={handleAddVehicle}
                                        className=" cusNoNotFoundDiaBtnHeight"
                                    />
                                </Col>
                            </Row>
                        </Stack>
                    </div>
                </>
            </Modal>
        </>
    );
};

const theme = getTheme();
const contentStyles = mergeStyleSets({
    container: {
        width: 450,
        zIndex: 100,
    },
    header: {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "5px 30px",
    },

    body: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: "34px",
        selectors: {
            p: { margin: "14px 0" },
            "p:first-child": { marginTop: 0 },
            "p:last-child": { marginBottom: 0 },
        },
    },
    footer: {
        padding: "0px 30px",
        paddingBottom: 15,
    },
});
const iconButtonStyles = {
    root: {
        color: theme.palette.neutralPrimary,
        marginLeft: "auto",
        marginTop: "4px",
        marginRight: "2px",
    },
    rootHovered: {
        color: theme.palette.neutralDark,
    },
};
